
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Chart } from 'react-google-charts';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const useStylesSelection = makeStyles(theme => ({
  formControl: {
    alignItems: 'Center',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const ReportMap = ({
  displayData, allData,
}) => {
  const classes = useStylesSelection();
  const [locationData, setlocationData] = React.useState(displayData);
  const changeTarget = (event) => {
    if (event.target.value === 'Top') {
      setlocationData(displayData);
    }
    else {
      setlocationData(allData);
    }
  };
  return (
    <FormControl fullWidth className={classes.formControl}>
      <RadioGroup row aria-label="position" name="position" defaultValue="Top" onChange={changeTarget}>
        <FormControlLabel value="Top" control={<Radio color="primary" />} label="Top rated" />
        <FormControlLabel value="All" control={<Radio color="primary" />} label="All Hosptial" />
      </RadioGroup>
      <Chart
        textAlign="center"
        width="100%"
        height="400px"
        chartType="GeoChart"
        data={locationData}
        options={{
          region: 'US',
          resolution: 'provinces',
          displayMode: 'markers',
          colorAxis: { colors: ['#f2f2f2', '#1EB0BC', '#CD56C4'] },
          backgroundColor: '#F4F6F8',
          datalessRegionColor: '#ebecf0',
        }}
        // AIzaSyA1sKODjN9cOvDasxpaqs3sZE8ag7BEOBQ
        // AIzaSyBMAEqhvuwPdj_9TO2mB1l_2LguumnPidU
        // AIzaSyDKhjLxJXb4x2cKu5dlrCqTphk-LmuaFys
        mapsApiKey="AIzaSyDKhjLxJXb4x2cKu5dlrCqTphk-LmuaFys"
        // mapsApiKey="AIzaSyAnb3UXseHgpq1V62ydRA7A2-4lusU7slg"
        
        rootProps={{ 'data-testid': '2' }}
      />

    </FormControl>

  );
};

ReportMap.propTypes = {
  displayData: PropTypes.object.isRequired,
  allData: PropTypes.object.isRequired,
};
export default ReportMap;



// WEBPACK FOOTER //
// ./src/components/ReportMap/ReportMap.js